import { ReactNode, RefObject, useContext, useLayoutEffect, useRef } from 'react'

import { useBlockScroll, useEscPress, useStack } from 'ui/hooks'

import { useOutsideClick } from '../../hooks'
import { IconName } from '../Icon'
import { SidePanelContext } from './context'

import * as SC from './styles'

type Props = {
  isCloseOnOutsideClick?: boolean
  isBlockScrolling?: boolean
  referenceRef: RefObject<HTMLElement>
  referenceNode?: Element
  children: ReactNode
}

export const Box = (props: Props) => {
  const { isCloseOnOutsideClick, isBlockScrolling, referenceRef, referenceNode, children } = props

  const context = useContext(SidePanelContext)

  const sidePanelRef = useRef(null)

  useEscPress(context.close)
  useStack(sidePanelRef)
  useOutsideClick(sidePanelRef, context.close, isCloseOnOutsideClick)
  useBlockScroll(isBlockScrolling)

  useLayoutEffect(() => {
    const refNode = referenceRef.current || referenceNode

    if (refNode) {
      refNode.classList.add('sidepanel')
    }

    return () => {
      if (refNode) {
        refNode.classList.remove('sidepanel')
      }
    }
  }, [referenceRef, referenceNode])

  return (
    <SC.Box $opened={context.isOpened} ref={sidePanelRef}>
      <SC.CloseIcon name={IconName.CROSS_SMALL} onClick={() => context.close()} />
      {children}
    </SC.Box>
  )
}
